import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CommentSection from 'app/components/layouts/Comments/CommentSection';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import { withGlobalData } from 'app/utils/withGlobalData';
import Title from 'app/components/layouts/Title';
import Image from 'app/components/layouts/Image';
import * as topicApi from 'app/requests/topics';
import { useTranslation } from 'next-i18next';
import { Category } from 'types/category';
import { useRouter } from "next/router";
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import env from '.env.json';

export default function index({ categories }) {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <section className="box-card-area">
      <NextSeo
        title={t('home.info_vocabulary')}
        description={`${t('vocabulary.description_vocabularies')}`}
      />
      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <Title title="home.info_vocabulary" />
            <div className="my-8">
              {
                (categories.data || [])
                  .map((category: Category) => {
                    return (
                      <div key={category.id} className="wrap-box-content text-left py-5">
                        <Link
                          className="font-weight-bold text-size-md p-3 m-2"
                          href={`/vocabularies/topics/${category[`slug_${router.locale}`]}`}
                        >
                          <Image
                            alt=""
                            width={30}
                            height={30}
                            className="mr-3"
                            disableAuto
                            src={`/images/vocabularies/${category.slug}.webp`}
                          />
                          <div className="d-inline route-name">
                            {category?.title[router.locale ?? env.DEFAULT_LOCALE]}
                          </div>
                        </Link>
                      </div>
                    )
                  })
              }
            </div>
            <CommentSection roomId="vocabularies" />
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale }) => {
  try {
    const [categories, translations] = await Promise.all([
      topicApi.list({ from: 'home_page', code: locale }),
      serverSideTranslations(locale, ['common']),
    ]);

    return {
      props: {
        ...translations,
        categories,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});

